import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: '0 0 18px',
    padding: '0 40px',
    ['@media (max-width:600px)']: {
      padding: 0
    }
  },
  defaultMenu: {
    ['@media (max-width:850px)']: {
      display: 'none'
    }
  },
  tabsRoot: {
    borderBottom: '1px solid #e2ebf6',
    minHeight: '42px',
    overflow: 'visible',
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tabsFixed: {
    height: '42px',
    overflow: 'visible !important'
  },
  tabNumber: {
    width: '18px',
    height: '18px',
    margin: '2px 12px 2px 2px',
    fontSize: '13px',
    lineHeight: '13px',
    borderRadius: '100px',
    boxShadow: 'none',
    backgroundColor: theme.baseUI.color,
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  doneIcon: {
    color: theme.baseUI.color,
    fontSize: '22px',
    marginRight: '10px'
  },
  tabLabelWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  tabsIndicator: {
    backgroundColor: theme.baseUI.color
  },
  tab: {
    minHeight: '42px',
    height: '42px',
    padding: '6px 15px',
    minWidth: '126px',
    overflow: 'visible',
    ['@media (max-width:465px)']: {
      minWidth: '77px'
    }
  },
  isDoneTab: {
    opacity: 1
  },
  selected: {
    fontWeight: 'bold'
  },
  dateRange: {
    width: '210px'
  },
  dateRangeInput: {
    border: 'none !important',
    boxShadow: 'none'
  },

  search: {
    display: 'flex',
    height: '76px',
    border: '1px solid #E2EBF6',
    borderRadius: '3px',
    padding: '18px',
    marginTop: '10px'
  },
  searchDate: {
    minWidth: '25%',
    borderRight: '1px solid #E2EBF6',
    marginRight: '15px',
    paddingRight: '15px'
  },
  searchLabel: {
    fontSize: '13px',
    lineHeight: '18px',
    margin: '0',
    paddingBottom: '4px',
    fontWeight: '600',
    textTransform: 'capitalize',
    cursor: 'pointer'
  },
  searchInput: {
    border: 0,
    color: theme.baseUI.color,
    fontSize: '15px',
    lineHeight: '18px',
    fontWeight: '600',
    padding: 0,
    cursor: 'pointer',

    '&:hover': {
      border: 0
    },

    '& svg': {
      marginLeft: '7px'
    },

    ['@media (max-width: 700px)']: {
      '& svg': {
        display: 'none'
      }
    }
  },
  guests: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  guestsField: {
    width: '100px',

    ['@media (max-width: 700px)']: {
      width: '70px'
    }
  },
  searchBtn: {
    border: `1px solid ${theme.baseUI.color}`,
    borderRadius: '3px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 600,
    color: theme.baseUI.color,
    width: '100px',
    height: '30px',

    ['@media (max-width: 700px)']: {
      width: '30px',
      minWidth: '30px',
      padding: '5px 5px'
    }
  },
  guestsSelectRoot: {
    padding: '0 10px 0 0',
    color: theme.baseUI.color,
    fontSize: '15px',
    lineHeight: '18px',
    fontWeight: '600'
  },
  guestsInputBase: {
    border: 0,
    '&:hover': {
      border: 0
    },
    '& .MuiSelect-icon': {
      color: theme.baseUI.color
    }
  },
  guestsLabel: {
    fontSize: '13px',
    lineHeight: '18px',
    margin: '0',
    paddingBottom: '4px',
    fontWeight: '600',
    textTransform: 'capitalize'
  }
}));
export default useStyles;
